<script setup lang="ts">

import BaseContainer from "@/core/components/base/BaseContainer.vue";
import {ApodisPremiumContentfulEntries} from "@/contentful/interfaces/contentful";
import {Check} from "@lucide/vue";
import RichTextRenderer from "contentful-rich-text-vue-renderer";
import contentfulHelper from "@/core/helpers/contentfulHelper";
import {storeToRefs} from "pinia";
import {useSubscriptionPlanStore} from "@/stores/subscription-plan.store";
import {computed} from "vue";
import SubscriptionDetails from "@/subscription-plan/components/SubscriptionDetails.vue";
import HomeSponsorship from "@/home/components/HomeSponsorship.vue";

defineProps<{
    data: ApodisPremiumContentfulEntries
}>();

const {globalPlan} = storeToRefs(useSubscriptionPlanStore());

const activeSubscription = computed(() => {
    if (!globalPlan.value) {
        return false;
    }

    return globalPlan.value.subscriptions?.find(subscription => subscription.status === 'active');
});
</script>

<template>
  <div class="h-full flex flex-col">
    <BaseContainer class="gradient flex-1">
      <div class="py-8 px-6 max-w-7xl mx-auto space-y-8 flex flex-col h-full">
        <div class="text-center">
          <h1 class="text-4xl font-bold text-white">
            Vous êtes Premium
            <Check class="inline-block w-12 h-12 stroke-[4px] text-secondary" />
          </h1>
          <p class="text-secondary text-lg font-medium">
            Toute l'équipe Apodis vous remercie pour votre soutien !
          </p>
        </div>
        <div class="sales-pitch text-white font-medium">
          <RichTextRenderer :document="data.subscribedSalesPitch" :node-renderers="contentfulHelper.renderNodes()" />
        </div>
        <div class="bg-white rounded-lg p-6 space-y-8 shadow-[5px_5px_0_0_#65efca]">
          <SubscriptionDetails v-if="activeSubscription" :subscription-id="activeSubscription.id" />
        </div>
        <div class="flex-1" />
        <div class="pt-8">
          <HomeSponsorship class="w-full" />
        </div>
      </div>
    </BaseContainer>
  </div>
</template>

<style scoped>
:deep(.sales-pitch ul) {
    @apply !pl-0;
}

.sales-pitch:deep(a) {
    @apply !text-secondary underline;
}

:deep(.sales-pitch li) {
    @apply flex items-start;
    list-style: none;
}

:deep(.sales-pitch li) {
    @apply mb-2 !important;
}

:deep(.sales-pitch li::before) {
    content: "✓";
    @apply text-secondary text-3xl top-2 relative;
    margin-right: 10px;
}
</style>
